import { useUser } from "@/hooks/useUser";

export function useInHouseNotifications(): boolean {
  const { data: user } = useUser();

  return Boolean(user?.useInHouseNotifications);
}
